export default "__VITE_ASSET__0b060d7f__"